<div class="overlay" *ngIf="isVisible">
  <div class="overlay-content">
		<div>
			<svg-icon class="icon-info" key="liveSupport" size="xxl"></svg-icon>
		</div>
    <div>{{ confirmMessage }}</div>
    <div class="step-button step-button--primary" (click)="confirmClose()">{{ primaryText }}</div>
    <div class="step-button step-button--secondary" (click)="cancelClose()">{{ secondaryText }}</div>
  </div>
</div>